<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="新版后台" name="v1">
      <access-v2></access-v2>
    </el-tab-pane>
    <el-tab-pane label="旧版后台" name="v2">
      <access-v1></access-v1>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import AccessV1 from "@/components/sysSet/access/old/AccessV1.vue";
import AccessV2 from "@/components/sysSet/access/new/AccessV2.vue";

export default {
  name: 'AccessControl',
  components: {AccessV2, AccessV1},

  data() {
    return {
      activeName: "v1"
    };
  },
};
</script>

<style scoped>
</style>